
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[[...doc]]",
      function () {
        return require("private-next-pages/docs/[[...doc]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/[[...doc]]"])
      });
    }
  